(function () {
  function initStickyCartBar(bar) {
    if (!('IntersectionObserver' in window)) return;

    var watchId = bar.getAttribute('data-watch-id');
    var watchTarget = watchId ? document.getElementById(watchId) : null;
    if (!watchTarget) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('sticky-cart-bar--visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );

    observer.observe(watchTarget);
  }

  document.querySelectorAll('[data-sticky-cart-bar]').forEach(initStickyCartBar);
})();
